import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var basicPath = 'M34.63 8.64001V38.83L25.34 32.74C24.9288 32.4694 24.4473 32.3253 23.955 32.3253C23.4628 32.3253 22.9813 32.4694 22.57 32.74L13.63 38.74V8.64001H34.63ZM36.13 6.14001H12.13C11.8648 6.14001 11.6104 6.24536 11.4229 6.43289C11.2354 6.62043 11.13 6.8748 11.13 7.14001V41.59C11.13 41.8552 11.2354 42.1096 11.4229 42.2971C11.6104 42.4847 11.8648 42.59 12.13 42.59C12.3266 42.5922 12.5189 42.5328 12.68 42.42L24 34.83L35.61 42.45C35.7611 42.5495 35.9364 42.6062 36.1171 42.6139C36.2979 42.6217 36.4774 42.5803 36.6365 42.494C36.7955 42.4078 36.9283 42.2801 37.0204 42.1244C37.1126 41.9687 37.1608 41.7909 37.16 41.61V7.14001C37.16 6.8748 37.0547 6.62043 36.8671 6.43289C36.6796 6.24536 36.4252 6.14001 36.16 6.14001H36.13Z';
var filledPath = 'M35.9 42.45L24.29 34.83L13 42.42C12.8495 42.5217 12.6741 42.5805 12.4927 42.5901C12.3113 42.5997 12.1307 42.5597 11.9703 42.4743C11.8099 42.389 11.6758 42.2616 11.5824 42.1058C11.489 41.95 11.4397 41.7717 11.44 41.59V7.14001C11.44 6.8748 11.5454 6.62043 11.7329 6.43289C11.9204 6.24536 12.1748 6.14001 12.44 6.14001H36.44C36.7052 6.14001 36.9596 6.24536 37.1471 6.43289C37.3346 6.62043 37.44 6.8748 37.44 7.14001V41.61C37.4397 41.7894 37.3912 41.9653 37.2995 42.1195C37.2078 42.2737 37.0763 42.4003 36.9188 42.4862C36.7614 42.5721 36.5837 42.6141 36.4045 42.6077C36.2252 42.6013 36.051 42.5469 35.9 42.45Z';
var BookmarkIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var iconFill = _ref.iconFill,
      props = _objectWithoutProperties(_ref, ["iconFill"]);

  var path = basicPath;

  if (iconFill && iconFill === 'fill') {
    path = filledPath;
  }

  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: path
  }));
});
BookmarkIcon.displayName = 'BookmarkIcon';
BookmarkIcon.defaultProps = {
  'aria-label': 'Bookmark'
};
export default BookmarkIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/BookmarkIcon/index.js
// module id = 1790
// module chunks = 12